import { parseWellLogsManagerWidgetInternalState } from 'src/pages/dashboard/features/well-logs-manager-widget/parseWellLogsManagerWidget';
import { WellLogsManagerWidgetEntity } from 'src/pages/dashboard/features/well-logs-manager-widget/WellLogsManagerWidget.entity';

import type { TSerializedWidget } from 'src/entities/workspace/types';

export function mapWellLogsManagerWidget(widget: TSerializedWidget, index: number): WellLogsManagerWidgetEntity {
  const internalState = parseWellLogsManagerWidgetInternalState(widget.internalState);

  const newWellLogsManagerWidget = new WellLogsManagerWidgetEntity(
    {
      wellId: internalState.wellId,
      stateParams: internalState.stateParams,
      type: 'well-logs-manager-widget',
    },
    {
      uuid: widget.uuid,
      isPinned: !!widget.isPinned,
      zIndex: index + 1,
      isFullscreen: widget.isFullscreen ?? false,
      position: {
        x: widget?.position?.x ?? 0,
        y: widget?.position?.y ?? 0,
      },
      size: {
        w: widget.size?.w ?? 59,
        h: widget.size?.h ?? 316,
      },
      groupId: widget.groupId,
      isGroupsDefaultOpened: false,
    }
  );

  return newWellLogsManagerWidget;
}
